import { router } from '@inertiajs/react'
import { Badge } from '@/components/ui/badge'
import FdeRecordStatus from '@/frontend/features/Fde/FdeRecordStatus'
import RecordActions from '@/frontend/features/Fde/RecordActions'
import type { Evidence, FdeCopy } from '@/frontend/features/Fde/types'
import { fdeRoutes } from '@/frontend/features/Fde/routes'

export default function EvidenceList({ evidences, projectId, copy, canManage, onEdit }: { evidences: Evidence[]; projectId: string; copy: FdeCopy; canManage: boolean; onEdit: (evidence: Evidence) => void }) {
  function remove(evidence: Evidence) {
    if (window.confirm(copy.common.confirm_delete)) router.delete(`${fdeRoutes.evidences}/${evidence.id}?project_id=${projectId}`, { preserveScroll: true })
  }
  function confirm(evidence: Evidence) {
    router.patch(`${fdeRoutes.evidences}/${evidence.id}?project_id=${projectId}`, { evidence: { status: 'confirmado' } }, { preserveScroll: true })
  }

  if (evidences.length === 0) return <p className="p-6 text-center text-sm text-muted-foreground">{copy.workspace.no_evidences}</p>
  return (
    <div className="divide-y divide-border">
      {evidences.map((evidence) => (
        <article key={evidence.id} className="flex gap-3 px-4 py-3 hover:bg-muted/30">
          <div className="min-w-0 flex-1"><div className="flex flex-wrap items-center gap-2"><h3 className="truncate text-sm font-medium">{evidence.title}</h3><Badge variant="outline">{evidence.evidence_kind}</Badge><FdeRecordStatus status={evidence.status} proposedLabel={copy.workspace.proposed} confirmedLabel={copy.workspace.confirmed_status} /></div>{evidence.subject_label && <p className="mt-1 truncate text-xs text-primary">{evidence.subject_label}</p>}{evidence.excerpt && <p className="mt-1 line-clamp-2 text-xs leading-5 text-muted-foreground">{evidence.excerpt}</p>}</div>
          {canManage && <RecordActions proposed={evidence.status === 'proposto'} copy={copy} onEdit={() => onEdit(evidence)} onConfirm={() => confirm(evidence)} onDelete={() => remove(evidence)} />}
        </article>
      ))}
    </div>
  )
}
